import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';
import { SamplesModule } from '@app/samples/samples.module';
import { SamplesComponent } from '@app/samples/samples.component';

const apiUrl = 'https://api-sdoh.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  modules: [
    SamplesModule
  ],
  production: false,
  routes: [
    {
      path: ':tenantId/sdoh',
      component: SamplesComponent,
      children: [
        // Add Sample pages here. Use the code below as a guide.
        // { path: 'sdoh-component', component: SamplePageComponent, data: { title: 'SDOH Component' } },
      ]
    },
  ],
  version: buildVersion as BuildVersion,
};
